import { render, staticRenderFns } from "./chairScreenControl.vue?vue&type=template&id=734861ae"
import script from "./chairScreenControl.vue?vue&type=script&lang=js"
export * from "./chairScreenControl.vue?vue&type=script&lang=js"
import style0 from "./chairScreenControl.vue?vue&type=style&index=0&id=734861ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports